import useNavigateWithSearch from '../../../../../../hooks/useNavigateWithSearch';
import { useFirebaseAuth } from '../../../../../global/FirebaseProvider/FirebaseProvider';
import MembershipPerks from '../../../MembershipDashboard/MembershipPerks';
import { Button, BUTTON_TYPE, BUTTON_SIZE } from '../../../../global/Button';
import { ROUTE_MEMBERSHIP } from '../../../../config/routes';
import { SUPPORT_URL } from '../../../../config/externalURL';

import './PerksStep.scss';

const PerksStep = ({ onHandleNext }) => {
  const navigateWithSearch = useNavigateWithSearch();
  const { userData } = useFirebaseAuth();

  return (
    <div className="PerksStep">
      <div className="PerksStep__container">
        <div className="PerksStep__container--wrapContent">
          <div className="PerksStep__container--header">
            {`${userData?.firstName ? `${userData.firstName}, ` : ''}have you used all the perks?`}
          </div>
          <div className="PerksStep__container--content">
            <MembershipPerks />
            <div className="PerksStep__container--content-help">
              Questions or issue?
              {' '}
              <a href={SUPPORT_URL}>Get Help</a>
            </div>
          </div>
        </div>

        <div className="PerksStep__container--footer">
          <Button
            type={BUTTON_TYPE.LINK_SEPTENARY}
            size={BUTTON_SIZE.LARGE}
            onClick={onHandleNext}
          >
            Continue to cancel
          </Button>
          <Button
            type={BUTTON_TYPE.QUATERNARY}
            size={BUTTON_SIZE.LARGE}
            onClick={() => navigateWithSearch(ROUTE_MEMBERSHIP)}
          >
            Keep Trashie Unlimited
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PerksStep;
